import { Clock,Plus,CheckCircle,AlertTriangle,Trash2 } from "lucide-react";
import CustomButton from "../../component/button";

const QB_CSS = `
.qb-timer-bar { background: var(--color-indigo-100, #e0e7ff); border-color: var(--color-blue-200, #bfdbfe); }
.qb-row { transition: border-color .15s ease, box-shadow .15s ease; }
.qb-row:hover, .qb-row:focus-within { border-color: var(--brand-primary, #2563eb) !important; }
.qb-row:focus-within { box-shadow: 0 0 0 .15rem var(--color-indigo-100, #e0e7ff); }
.qb-input { border: none; outline: none; background: transparent; }
.qb-input:focus { box-shadow: none; }
.qb-timer-chip { background: #f8f9fa; border: 1px solid #e9ecef; }
.qb-timer-chip:hover { border-color: #dee2e6; }
/* hide number spinners */
.qb-no-spin::-webkit-outer-spin-button,
.qb-no-spin::-webkit-inner-spin-button { -webkit-appearance: none; margin: 0; }
.qb-no-spin { -moz-appearance: textfield; }
/* reveal delete on row hover (desktop) */
.qb-delete { color: #d1d5db;  }
// .qb-delete:hover { color: var(--bs-danger); }

`;

export default function TechnicalQues({ config, setConfig, addQuestion }) {
  return (
    <>
      <style>{QB_CSS}</style>

      <div className="d-flex flex-column gap-3" style={{  }}>

        {/* Timer bar */}
        <div className="qb-timer-bar d-flex align-items-center justify-content-between gap-3 p-2 rounded border shadow-sm">
          <div className="d-flex align-items-center gap-2">
            <Clock size={14} className="text-primary" />
            <span className="small fw-semibold text-primary-emphasis text-nowrap">Default Timer (Mins):</span>
            <input
              type="number"
              className="form-control form-control-sm text-center qb-no-spin"
              style={{ width: '3.5rem' }}
              value={config.timerMinutes}
              onChange={(e) => setConfig({ ...config, timerMinutes: e.target.value })}
              min="1" max="15"
            />
          </div>
          
          <CustomButton
          title='Apply to All'
          buttonType='secondary'
          handleClick={() => {
              const updatedQ = config.questions.map(q => ({ ...q, timerMinutes: config.timerMinutes }));
              setConfig({ ...config, questions: updatedQ });
            }}
          />
        </div>

        {/* Header */}
        <div>
          <div className="d-flex justify-content-between align-items-center mb-2">
            <label className="form-label m-0">Custom Question Bank</label>
            <CustomButton
          title={<><Plus size={14} /> Add Question</>}
          buttonType='tertiory'
          handleClick={addQuestion} 
          />
          </div>

          {/* Rows */}
          <div className="d-flex flex-column gap-2">
            {config.questions.map((q, index) => (
              <div
                key={q.id}
                className="qb-row d-flex align-items-center gap-2 border rounded p-2 bg-white shadow-sm"
              >
                <div className="flex-shrink-0 text-center fw-bold text-secondary small" style={{ width: '1.5rem' }}>
                  {index + 1}.
                </div>

                <input
                  type="text"
                  className="qb-input form-control form-control-sm flex-grow-1 small text-dark"
                  placeholder="Type your technical or behavioral question here..."
                  value={q.text}
                  onChange={(e) => {
                    const newQ = [...config.questions];
                    newQ[index].text = e.target.value;
                    newQ[index].isClean = !(/age|family/i.test(e.target.value));
                    setConfig({ ...config, questions: newQ });
                  }}
                />

                {/* Lint status */}
                {/* {q.text.length > 0 && (
                  <div
                    className="flex-shrink-0 d-flex justify-content-center"
                    style={{ width: '1.25rem' }}
                    title={q.isClean ? 'Passed AI Linting' : 'Flagged: Protected Characteristics'}
                  >
                     {q.isClean
                      ? <CheckCircle size={14} className="text-success" />
                      : <AlertTriangle size={14} className="text-danger" />} 
                  </div>
                )} */}

                <div className="vr d-none d-sm-block mx-1" style={{ height: '2.2rem' }}></div>

                {/* Per-question timer */}
                <div
                  className="qb-timer-chip d-flex align-items-center gap-1 flex-shrink-0 rounded px-2 py-1"
                  title="Time limit for this specific question"
                >
                  <Clock size={11} className="text-secondary" />
                  <input
                    type="number"
                    className="qb-input qb-no-spin text-center fw-medium text-secondary"
                    style={{ width: '2rem', fontSize: '11px',height:'28px' }}
                    value={q.timerMinutes || ''}
                    onChange={(e) => {
                      const newQ = [...config.questions];
                      newQ[index].timerMinutes = e.target.value;
                      setConfig({ ...config, questions: newQ });
                    }}
                    min="1"
                  />
                  <span className="text-secondary fw-medium" style={{ fontSize: '11px' }}>m</span>
                </div>

                {/* Delete */}
                <button
                  onClick={() => setConfig({ ...config, questions: config.questions.filter(item => item.id !== q.id) })}
                  className="qb-delete btn p-1 flex-shrink-0 border-0"
                  title="Remove Question"
                >
                  <Trash2 size={14} />
                </button>
              </div>
            ))}

            {config.questions.length === 0 && (
              <div className="text-center py-4 border border-dashed rounded text-secondary small bg-light">
                No custom questions added. AI will use standard defaults.
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}